import { Badge, Button, DatePicker, Dropdown, Form, Input, Select } from 'antd'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import {
  DATE_FORMAT_DEFAULT,
  DATE_FORMAT_SLASH,
  SHOPPING_STATUS,
  SHOPPING_USER_TYPE,
} from '../../constants'
import { checkValidFormFieldValue } from '../../utils/helper'

const ShoppingCouponPageAdvanceFilterV2 = () => {
  const [showFilter, setShowFilter] = useState(false)

  const history = useHistory()
  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        createUser: queryStringParse?.createUser || undefined,
        createdDate:
          queryStringParse?.createdDate && queryStringParse?.createdDate
            ? moment(queryStringParse.createdDate, DATE_FORMAT_SLASH)
            : undefined,
        type: queryStringParse?.type || undefined,
        userType: queryStringParse?.userType || undefined,
      })
    }
  }, [queryStringParse, setFieldsValue, showFilter])

  const onFinish = values => {
    const params = {
      createUser: values?.createUser || null,
      createdDate: values?.createdDate
        ? moment(values?.createdDate).format(DATE_FORMAT_SLASH)
        : null,
      type: values?.type || null,
      userType: values?.userType || null,
    }

    const queryStringStringify = queryString.stringify(
      {
        ...params,
        title: queryStringParse?.title || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )

    history.push(`/shopping-coupon?${queryStringStringify}`)
    onToggleFilter()
  }

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryStringParse?.createUser)) count++
    if (hasValue(queryStringParse?.createdDate)) count++
    if (hasValue(queryStringParse?.type)) count++
    if (hasValue(queryStringParse?.userType)) count++

    return count
  }, [queryStringParse])

  const handleClearFilter = () => {
    const queryStringStringify = queryString.stringify(
      {
        title: queryStringParse?.title || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )

    history.push(`/shopping-coupon?${queryStringStringify}`)
  }

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item
                label="Người tạo"
                name="createUser"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Lọc theo người tạo"
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Ngày tạo"
                name="createdDate"
                style={{ marginBottom: 16 }}>
                <DatePicker
                  style={{ width: '100%' }}
                  allowClear
                  placeholder={'Lọc theo ngày tạo'}
                  format={DATE_FORMAT_SLASH}
                  className="h-40"
                />
              </Form.Item>

              <Form.Item
                label="Trạng thái"
                name="type"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  className="h-40"
                  placeholder={'Lọc theo trạng thái'}
                  allowClear>
                  <Select.Option value={SHOPPING_STATUS.CREATED}>
                    Chờ xử lý
                  </Select.Option>
                  <Select.Option value={SHOPPING_STATUS.REQUESTED}>
                    Đã duyệt yêu cầu
                  </Select.Option>
                  <Select.Option value={SHOPPING_STATUS.APPROVED}>
                    Đã thẩm định
                  </Select.Option>
                  <Select.Option value={SHOPPING_STATUS.BOUGHT}>
                    Đã mua
                  </Select.Option>
                  <Select.Option value={SHOPPING_STATUS.PAID}>
                    Hoàn thành
                  </Select.Option>
                  <Select.Option value={SHOPPING_STATUS.REJECT}>
                    Đã hủy
                  </Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Loại"
                name="userType"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  className="h-40"
                  placeholder={'Lọc theo loại'}
                  allowClear>
                  <Select.Option value={SHOPPING_USER_TYPE.CREATED}>
                    Đã tạo
                  </Select.Option>
                  <Select.Option value={SHOPPING_USER_TYPE.PROCESS}>
                    Xử lý
                  </Select.Option>
                  <Select.Option value={SHOPPING_USER_TYPE.FOLLOW}>
                    Theo dõi
                  </Select.Option>
                </Select>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleClearFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default ShoppingCouponPageAdvanceFilterV2
